// #region agent log
fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:1',message:'Script loaded',data:{timestamp:Date.now()},timestamp:Date.now(),sessionId:'debug-session',runId:'init',hypothesisId:'A'})}).catch(()=>{});
// #endregion

class ScrollToTopButton extends HTMLElement {
  #scrollThreshold = 300;
  #scrollHandler = null;
  #rafId = null;
  #isVisible = false;

  connectedCallback() {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:10',message:'connectedCallback called',data:{elementExists:!!this,scrollThreshold:this.#scrollThreshold},timestamp:Date.now(),sessionId:'debug-session',runId:'init',hypothesisId:'B'})}).catch(()=>{});
    // #endregion

    this.#scrollHandler = this.#handleScroll.bind(this);
    
    // Use requestAnimationFrame for better performance
    let ticking = false;
    const rafHandler = () => {
      this.#handleScroll();
      ticking = false;
    };

    const scrollListener = () => {
      if (!ticking) {
        this.#rafId = requestAnimationFrame(rafHandler);
        ticking = true;
      }
    };

    window.addEventListener('scroll', scrollListener, { passive: true });
    window.addEventListener('resize', this.#handleScroll.bind(this), { passive: true });
    this.addEventListener('click', this.#scrollToTop.bind(this));
    
    // Initial check
    this.#handleScroll();

    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:35',message:'Event listeners attached',data:{hasScrollHandler:!!this.#scrollHandler},timestamp:Date.now(),sessionId:'debug-session',runId:'init',hypothesisId:'B'})}).catch(()=>{});
    // #endregion
  }

  disconnectedCallback() {
    if (this.#rafId) {
      cancelAnimationFrame(this.#rafId);
    }
    window.removeEventListener('scroll', this.#scrollHandler);
    window.removeEventListener('resize', this.#handleScroll);
  }

  #handleScroll() {
    // #region agent log
    const scrollTopBefore = window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0;
    // #endregion

    const scrollTop = Math.max(
      window.pageYOffset || 0,
      document.documentElement.scrollTop || 0,
      document.body.scrollTop || 0,
      window.scrollY || 0
    );

    const isVisible = scrollTop > this.#scrollThreshold;

    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:55',message:'Scroll handler executed',data:{scrollTop:scrollTop,scrollTopBefore:scrollTopBefore,threshold:this.#scrollThreshold,isVisible:isVisible,wasVisible:this.#isVisible,windowInnerHeight:window.innerHeight,windowInnerWidth:window.innerWidth},timestamp:Date.now(),sessionId:'debug-session',runId:'scroll',hypothesisId:'C'})}).catch(()=>{});
    // #endregion

    if (isVisible !== this.#isVisible) {
      this.#isVisible = isVisible;
      
      if (isVisible) {
        this.setAttribute('data-visible', 'true');
        // #region agent log
        fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:65',message:'Setting visible=true',data:{computedStyle:window.getComputedStyle(this).display,zIndex:window.getComputedStyle(this).zIndex,opacity:window.getComputedStyle(this).opacity,visibility:window.getComputedStyle(this).visibility},timestamp:Date.now(),sessionId:'debug-session',runId:'scroll',hypothesisId:'D'})}).catch(()=>{});
        // #endregion
      } else {
        this.setAttribute('data-visible', 'false');
        // #region agent log
        fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:72',message:'Setting visible=false',data:{},timestamp:Date.now(),sessionId:'debug-session',runId:'scroll',hypothesisId:'D'})}).catch(()=>{});
        // #endregion
      }
    }
  }

  #scrollToTop(e) {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:79',message:'Scroll to top clicked',data:{currentScroll:window.pageYOffset || document.documentElement.scrollTop},timestamp:Date.now(),sessionId:'debug-session',runId:'click',hypothesisId:'E'})}).catch(()=>{});
    // #endregion

    e.preventDefault();
    e.stopPropagation();
    
    const scrollToTop = () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (currentScroll > 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        // #region agent log
        fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:92',message:'ScrollTo called',data:{currentScroll:currentScroll},timestamp:Date.now(),sessionId:'debug-session',runId:'click',hypothesisId:'E'})}).catch(()=>{});
        // #endregion
      }
    };

    scrollToTop();
  }
}

if (!customElements.get('scroll-to-top-button')) {
  customElements.define('scroll-to-top-button', ScrollToTopButton);
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/454d873b-7358-4e93-b062-dd9b7b265ea9',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'scroll-to-top.js:100',message:'Custom element defined',data:{elementName:'scroll-to-top-button'},timestamp:Date.now(),sessionId:'debug-session',runId:'init',hypothesisId:'A'})}).catch(()=>{});
  // #endregion
}
